import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import _ from "lodash"
import {useSelector} from 'react-redux'

function QuoteLoader({ loop }) {
  const {theme} =useSelector(state=>state.theme)
  return (
    <>
      {_.times(loop !== undefined ? loop : 1, (key) => {
        return (
          <div key={key} className="quoteContainer">
            <SkeletonTheme baseColor={theme == "dark" ? "#202020" : "#f0f0f0"} highlightColor={theme == "dark" ? "#444" : "#f0f0f0"}>
              <p className="quote-text">
                <Skeleton height={"40px"} width= "250px" />
              </p>
            </SkeletonTheme>
          </div>
        );
      })}
    </>
  );
}

export default QuoteLoader


